// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { GetV1SubscriptionsData, GetV1SubscriptionsErrors, GetV1SubscriptionsResponses, GetV1TaxonomyData, GetV1TaxonomyErrors, GetV1TaxonomyResponses, PatchV1SubscriptionsData, PatchV1SubscriptionsErrors, PatchV1SubscriptionsResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get all notification classes
 */
export const getV1Taxonomy = <ThrowOnError extends boolean = false>(options?: Options<GetV1TaxonomyData, ThrowOnError>): RequestResult<GetV1TaxonomyResponses, GetV1TaxonomyErrors, ThrowOnError> => (options?.client ?? client).get<GetV1TaxonomyResponses, GetV1TaxonomyErrors, ThrowOnError>({ url: '/v1/taxonomy', ...options });

/**
 * Read the current configuration of notification class subscriptions
 *
 * Returns subscriptions scoped to the application specified by `app`, or all applications
 * when `app` is omitted.
 *
 * Categorical channel subscriptions are represented by the top-level `channels` property.
 * Subscriptions for each notification class can be configured separately, but if the whole
 * channel is disabled, no notifications through that channel will be delivered. Channels
 * that are not available for a class cannot be turned on.
 *
 * Only leaf classes are included. It is up to the UI to allow enabling or disabling
 * channels on other levels.
 *
 */
export const getV1Subscriptions = <ThrowOnError extends boolean = false>(options?: Options<GetV1SubscriptionsData, ThrowOnError>): RequestResult<GetV1SubscriptionsResponses, GetV1SubscriptionsErrors, ThrowOnError> => (options?.client ?? client).get<GetV1SubscriptionsResponses, GetV1SubscriptionsErrors, ThrowOnError>({ url: '/v1/subscriptions', ...options });

/**
 * Update the notification class subscription configuration
 *
 * Updates subscriptions scoped to the application specified by `app`, or all applications
 * when `app` is omitted.
 *
 * There might be differences between the input and the output. For example, classes that
 * cannot be enabled will stay disabled. Forced channels cannot be altered.
 *
 */
export const patchV1Subscriptions = <ThrowOnError extends boolean = false>(options: Options<PatchV1SubscriptionsData, ThrowOnError>): RequestResult<PatchV1SubscriptionsResponses, PatchV1SubscriptionsErrors, ThrowOnError> => (options.client ?? client).patch<PatchV1SubscriptionsResponses, PatchV1SubscriptionsErrors, ThrowOnError>({
    url: '/v1/subscriptions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
